import { Component, Inject, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'chicken-test',
    templateUrl: './chicken-test.component.html',
    styleUrls: ['./chicken-test.component.scss'],
    standalone: false
})
export class ChickenTestComponent {
    public action: string | undefined;
    public removeFromAllStatements: string | undefined;
    public removeFromAllCloseValue: any;
    public message: string | undefined;
    public positive: string | undefined;
    public positiveColor: string | undefined = 'primary';
    public negative: string | undefined = 'Cancel';

    constructor(public dialogRef: MatDialogRef<ChickenTestComponent>,
        @Optional() @Inject(MAT_DIALOG_DATA) public data?: { action?: string, message?: string, positive?: string, positiveColor?: string, negative?: string, removeFromAllStatements?: string, removeFromAllCloseValue?: any }
    ) {
        this.action = data?.action;
        this.message = data?.message;
        this.positive = data?.positive;
        this.positiveColor = data?.positiveColor;
        this.negative = data?.negative;
        this.removeFromAllStatements = data?.removeFromAllStatements;
        this.removeFromAllCloseValue = data?.removeFromAllCloseValue ?? 'removeFromAll';
    }

    capitalizeFirst(str: string) {
        const char = str.charAt(0);
        return char.toUpperCase() + str.substring(1);
    }

    setAction() {
        return `Are you sure you want to ${this.action}?`;
    }
}
